import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { FileDownloadModel } from '../../../../shared/models/file-download.model';
import { AssignmentContactingParticipantsResultModel } from '../models/assignment-contacting-participants-result.model';
import { AssignmentParticipantModel } from '../models/assignment-participants/assignment-participant.model';
import { AssignmentParticipantContactingPostModel } from '../models/assignment-participants/assignment-participants-contacting.model';

@Injectable({
    providedIn: 'root'
})
export class AssignmentsParticipantService {

    constructor(private httpClient: HttpClient) { }

    getAssignmentParticipants(assignmentId: number): Observable<AssignmentParticipantModel[]> {
        return this.httpClient.get<AssignmentParticipantModel[]>(`${environment.api}/assignments/${assignmentId}/participants`);
    }

    sendMessageToAssignmentParticipants(assignmentId: number, assignmentContactingParticipantsModel: AssignmentParticipantContactingPostModel): Observable<AssignmentContactingParticipantsResultModel> {
        return this.httpClient.post<AssignmentContactingParticipantsResultModel>(`${environment.api}/assignments/${assignmentId}/participants/contactParticipants`, assignmentContactingParticipantsModel);
    }

    downloadAssignmentParticipanstRegistrationDetails(assignmentId: number): Observable<FileDownloadModel> {
        return this.httpClient.get<FileDownloadModel>(`${environment.api}/assignments/${assignmentId}/participants/registrationDetails/download`);
    }
} 
